export interface WorldHolidaysChecker {
    isHoliday(date: Date): string|null;
}

function Easter(Y: number) {
    var C = Math.floor(Y/100);
    var N = Y - 19*Math.floor(Y/19);
    var K = Math.floor((C - 17)/25);
    var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
    I = I - 30*Math.floor((I/30));
    I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
    var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
    J = J - 7*Math.floor(J/7);
    var L = I - J;
    var M = 3 + Math.floor((L + 40)/44);
    var D = L + 28 - 31*Math.floor(M/4);

    return padout(M) + '-' + padout(D);
}

function getZieloneSwiatki(Y: number) {
    let easter = new Date(Y, parseInt(Easter(Y).substring(0,2)) - 1, parseInt(Easter(Y).substring(3,5)));
    let zieloneSwiatki = new Date(easter.getTime() + 49 * 24 * 60 * 60 * 1000);
    return padout(zieloneSwiatki.getMonth() + 1) + '-' + padout(zieloneSwiatki.getDate());
}


function getPoniedzialekWielkanocny(Y: number) {
    let easter = new Date(Y, parseInt(Easter(Y).substring(0,2)) - 1, parseInt(Easter(Y).substring(3,5)));
    let poniedzialekWielkanocny = new Date(easter.getTime() + 1 * 24 * 60 * 60 * 1000);
    return padout(poniedzialekWielkanocny.getMonth() + 1) + '-' + padout(poniedzialekWielkanocny.getDate());
}

function getBozeCialo(Y: number) {
    let easter = new Date(Y, parseInt(Easter(Y).substring(0,2)) - 1, parseInt(Easter(Y).substring(3,5)));
    let bozeCialo = new Date(easter.getTime() + 60 * 24 * 60 * 60 * 1000);
    return padout(bozeCialo.getMonth() + 1) + '-' + padout(bozeCialo.getDate());
}

function padout(v:number) { return (v < 10) ? '0' + v : v; }

export class HolidaysPL implements WorldHolidaysChecker {
    static isHoliday(date: Date): string|null {
        let MMDD = date.toISOString().substring(5, 10);
        if (MMDD === '01-01') return 'Nowy Rok';
        if (MMDD === '01-06') return 'Trzech Króli';
        if (MMDD === '05-01') return 'Święto Pracy';
        if (MMDD === '05-03') return 'Konstytucji 3 Maja';
        if (MMDD === '08-15') return 'Wniebowzięcie Najświętszej Maryi Panny';
        if (MMDD === '11-01') return 'Wszystkich Świętych';
        if (MMDD === '11-11') return 'Święto Niepodległości';
        if (MMDD === '12-25') return 'Boże Narodzenie';
        if (MMDD === '12-26') return 'Boże Narodzenie';
        if (MMDD === Easter(date.getFullYear())) return 'Wielkanoc';
        if (MMDD === getZieloneSwiatki(date.getFullYear())) return 'Zielone Świątki';
        if (MMDD === getPoniedzialekWielkanocny(date.getFullYear())) return 'Poniedziałek Wielkanocny';
        if (MMDD === getBozeCialo(date.getFullYear())) return 'Boże Ciało';

        // return Easter(date.getFullYear());
        return null;
    }

}

export const worldHolidaysList = {
    'pl': HolidaysPL,
}

export function isHolyday(country: string, dateYYYYMMDD: string): string|null {
    try {
        return worldHolidaysList[country].isHoliday(new Date(dateYYYYMMDD));
    } catch (e) {
        return null;
    }
}
